// src/components/layout/MenuSearchClient.tsx
"use client";

import React, { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";

export default function MenuSearchClient({
  searchAction,
  searchHeading,
}: {
  searchAction: string;
  searchHeading: string;
}) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const [value, setValue] = useState("");

  useEffect(() => {
    const urlValue = searchParams?.get("s") ?? "";
    setValue(urlValue);
  }, [searchParams]);

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();

    const q = value.trim();

    const url = q
      ? `${searchAction}?s=${encodeURIComponent(q)}`
      : searchAction;

    router.push(url);
  }

  return (
    <form onSubmit={onSubmit} className="relative hidden sm:block">
      <label className="sr-only" htmlFor="desktop-menu-search">
        {searchHeading}
      </label>

      <input
        id="desktop-menu-search"
        name="s"
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={searchHeading}
        inputMode="search"
        className="
          w-[192px] h-[42px] rounded-full border border-fuji-grey-dark
          px-5
          text-body-2 font-normal
          placeholder:text-black/50
          focus:outline-none focus:ring-2 focus:ring-fuji-grey
          appearance-none
          [&&::-webkit-search-cancel-button]:appearance-none
          [&&::-webkit-search-cancel-button]:hidden
        "
      />

      <button
        type="submit"
        aria-label="Search"
        className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          className="text-fuji-black/70"
        >
          <path
            d="M21 21l-4.35-4.35"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>
    </form>
  );
}
